import notify from './notify';
import Poll from './poll';
import MarkerClusterer from './google_maps_marker_clusterer';
import TxtOverlay from './google_maps_text_overlay';

/**
 * Shark activity model
 * @param json_url The url to fetch for the json feed.
 * @param images_url The base url for marker images.
 * @param popup_template A template function for the popup content.
 * @param $map
 * @param empty_template A template function for when there are no results.
 * @param PopupSlider The PopupSlider implementation to use.
 * @param action_template A template function to render activity results
 * @param alerts_url The url to poll for news and alerts
 * @param bens_url The url to the json for the bens
 */
var SharkActivity = function (json_url, images_url, popup_template, $map, empty_template, PopupSlider, action_template, alerts_url, bens_url, safety_layers_url) {

  var activity = this;

  // Pinmap instance, once it's loaded
  this.pinmap = null;

  // Api base url
  this.json_url = json_url;

  // Marker templates
  this.marker_template = popup_template;

  // Are we currently displaying small or large icons?
  this.small = null;

  // Generate unique icon styles for this map instance
  this.icon_styles = this.iconStyles(images_url);

  // Keep the map for use later with fullscreen mode
  this.$map = $map;

  // The template for when there are no results.
  this.empty_template = empty_template;

  // The popup slider implementation to use.
  this.PopupSlider = function ($element) {

    var pop = new PopupSlider($element);

    pop.closed = function () {
      setTimeout(function () {
        activity.drumline_popup_open = false;
      }, 500);
    };

    return pop;

  };

  // This is the template to render new activities with
  this.action_template = action_template;

  // Ui base for the pinmap
  this.$ui = null;

  // Watch for changes and update the toolbar if anything happens
  this.watcher = new notify();

  // Index markers by location on this property
  this.index = {};

  // Store which types of markers should be visible?
  this.visible_marker_types = ['detection', 'sighting'];
  this.init_visible_marker_types = ['detection', 'sighting'];
  this.visible_marker_types_previous = []; // Previous state of visible markers

  // Store the types which are clustered to prevent them being shown / hidden unintentionally
  this.clustered_marker_types = ['bens'];

  // Save the open popup target here, so we can reload it or whatever
  this.lastOpen = null;

  // If the 'special' popup with summary is shown, mark it here.
  this.summaryOpen = false;

  // Cutoff for displaying 'new' in detail view of a map location
  this.cutoff = Math.floor(new Date().getTime() / 1000);
  this._oldest_unused_cutoff = this.cutoff;

  // Summary info from the notifier
  this.summary = null;

  // Last set of summary data we loaded
  this.cache = null;
  this.cache_id = null;

  // Default clusterer styles
  this.defaultClustererStyles = {
    width: 70,
    height: 70,
    textColor: '#ffffff',
    textSize: 13,
    url: '/static/images/icons/map-icon-multiple-default.png',
  };

  // Ben json url;
  this.bens_url = bens_url;

  // The ben markers
  this.ben_markers = [];

  // The ben cluster instance
  this.bens_cluster = null;

  // The bens themselves
  this.bens = [];

  // The safety layer json url
  this.safety_layers_url = safety_layers_url;

  // The safety layer markers
  this.safety_layers = {};

  // Drumline status, active (actively baiting sharks) or inactive (safe, not baiting)
  this.drumline_active = true;

  // The drumline cluster instance
  this.drumline_cluster = null;

  // Smart drumline markers
  this.drumline_markers = [];

  // Smart drumline polygon
  this.drumline_polygon = null;

  // To prevent excess redraws
  this.drumline_active_changed = false;

  // The zoom level that the drumlines info marker becomes visible
  activity.drumline_info_marker_zoomlimit = 10;

  // Marker to show and zoom to drumline, also to show additional text if hidden
  this.drumline_info_marker = null;

  // Paths for polygon, used to generated bounds
  this.drumline_polygon_paths = null;

  // Bounds of drumline, used for pan+zoom
  this.drumline_bounds = null;

  this.drumline_popup = null;
  this.drumline_popup_open = false;

  this.drumlinePolylineStyles = {
    active: {
      strokeColor: '#21215d',
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: '#21215d',
      fillOpacity: 0.2
    },
    inactive: {
      strokeColor: '#787878',
      strokeOpacity: 1,
      fillColor: '#787878',
      fillOpacity: 0.2,
    }
  }

  var self = this;

  // Setup news alerts
  this._alerts = new Poll(alerts_url, 6000, function () {
    self.onAlertEvent();
  });
  this._bindAlertEvents();

  // Register a callback to this object that binds to click events
  window.openMapMarker = function (e) {
    self.handleMarkerEvent(e);
  };

  return this;
};

/**
 * Create and bind the pinmap api
 * @param ui The base ui element.
 *
 */
SharkActivity.prototype.load = function ($ui) {
  this.$ui = $ui;
  var activity = this;
  var width = $(window).width();
  var zoom_level = width < 640 ? 6 : 7;
  activity.$map.pinmap({
    'popup': new activity.PopupSlider(activity.$map),
    'latitude': -32.8097711,
    'longitude': 116.2,
    'zoom': zoom_level,
    'mapTypeControl': false,
    'centerOnMarker': true,
    'streetViewControl': false,
    'onMarkerClick': function (pinmap, marker) {
      activity.markerClick(pinmap, marker);
    },
    zoomControlOptions: {
      style: window.google.maps.ZoomControlStyle.LARGE,
      position: window.google.maps.ControlPosition.LEFT_TOP
    },
    panControl: true,
    panControlOptions: {
      position: window.google.maps.ControlPosition.LEFT_TOP
    }
  }, function (pinmap) {

    // Reset the open status when we close the map
    pinmap.popup.closed = function () {
      activity.untouchMarkers();
      activity.resetNotifications();
    };

    // Save so we can reload later
    activity.pinmap = pinmap;

    // On zoom change, check for the need to swap icons
    // We have to wait until here, when the map is loaded to bind this.
    google.maps.event.addListener(
      pinmap.google_map,
      'zoom_changed',
      function () {
        activity.zoomChanged();
      }
    );

    // Load initial data
    activity.reload($ui.find('.filter-time').val());

    // notification-panel
    activity.watcher.callback = function (summary) {
      activity.updated(summary, activity.watcher);
    };
    activity.watcher.watch();
    $('.notification-close').click(function (e) {
      activity.resetNotifications(true);
      e.preventDefault();
    });

    activity.updateBeaches();
    activity.setupInfoBoxControls();
    activity.noFlexboxHeight();
    activity.setupFilters();
    activity.initBens();
    activity.initSafetyLayers();
    activity.ensureTilesLoad();
    activity.setInitMarkers();
  });
};

SharkActivity.prototype.ensureTilesLoad = function () {
  var activity = this;

  // Make sure the map tiles load on slow conections
  activity.tilesLoaded = false;
  activity.loadChecker = null;
  activity.loadWait = null;
  activity.tileLoadTimeout = 5000;

  activity.pinmap.google_map.addListener('tilesloaded', function () {
    activity.tilesLoaded = true;
  });

  activity.pinmap.google_map.addListener('bounds_changed', function () {
    activity.tilesLoaded = false;
    // stop if already checking
    if (activity.loadChecker) {
      return false;
    }
    // debounce the wait function
    clearTimeout(activity.loadWait);
    if (!activity.tilesLoaded) {
      activity.loadWait = setTimeout(function () {
        activity.loadChecker = setInterval(function () {
          // cause a resize to trigger load of tiles
          window.google.maps.event.trigger(activity.pinmap.google_map, 'resize');
          if (activity.tilesLoaded) {
            clearInterval(activity.loadChecker);
            activity.loadChecker = null;
          }
        }, 1000);
      }, activity.tileLoadTimeout);
    }
  });
}

/* Dynamically adjust the height of the google map for users with no flexbox support */
SharkActivity.prototype.noFlexboxHeight = function () {
  var adjust_height = function () {
    var viewport_height = $(window).height();
    var header_height = $('header').height();
    var notifications_height = 0;
    if ($('body').hasClass('notification--active')) {
      notifications_height = $('#notification-panel').height();
    }
    var new_map_height = viewport_height - header_height - notifications_height;
    $('#shark_activity_map').css('height', new_map_height);
    $('#shark_activity_map .gm').css('height', new_map_height);
  };

  if ($('html').hasClass('no-flexbox')) {
    adjust_height();
    $(window).resize(function () {
      adjust_height();
    });
    $('body').on('notifications-toggled', function () {
      adjust_height();
    });
  }
};

SharkActivity.prototype.setInitMarkers = function () {
  var activity = this;
  var markersLoaded = setInterval(function () {
    if (activity.bens_loaded && activity.safety_layers_loaded) {
      clearInterval(markersLoaded);
      $.each(activity.visible_marker_types, function (i, type) {
        $('.filterset--key .key-selected [data-label="' + type + '"]').addClass('state--active');
        var listItem = $('.filterset--key label[for=map-pin--' + type + ']').closest('li');
        $(listItem).addClass('state--active');
        $(listItem).find('input').prop('checked', true);
      });
    }
  }, 100);
}

/* Sets up the filter options on the map */
SharkActivity.prototype.setupFilters = function () {
  var activity = this;
  var $filterset = $('.filterset--key');
  var $selected = $filterset.find('.key-selected');

  $selected.click(function () {
    // Close all info boxes
    activity.closeAllInfoboxes();
    $(this).parent().toggleClass('state--active');
  });

  $filterset.find('label').each(function () {
    $selected.find('.key-selected-item').each(function () {
      var type = $(this).data('label');
      if ($filterset.find('li.state--active #map-pin--' + type).length) {
        if ($.inArray(type, activity.visible_marker_types) === -1) {
          activity.visible_marker_types.push(type);
        }
      }
    });
  });

  $filterset.find('label').click(function () {
    activity.visible_marker_types_previous = [];
    Object.assign(activity.visible_marker_types_previous, activity.visible_marker_types);
    activity.visible_marker_types = [];
    $(this).parent().toggleClass('state--active');
    $selected.find('.key-selected-item').each(function () {
      var type = $(this).data('label');
      if ($filterset.find('li.state--active #map-pin--' + type).length) {
        $(this).addClass('state--active');
        activity.visible_marker_types.push(type);
        activity.toggleMarkers(type, true);
      } else {
        $(this).removeClass('state--active');
        activity.toggleMarkers(type, false);
      }
    });
  });

  // Setup the 'About' popup slider
  $filterset.find('.key-list--about a').click(function () {
    var about_template = Handlebars.compile($('#shark_activity_popup_about').html());
    var map = new activity.PopupSlider(activity.$map);
    map.setContent(about_template);
    activity.untouchMarkers();
    map.open();
  });
};

/* Allows the info boxes to be opened and close on desktop and mobile */
SharkActivity.prototype.setupInfoBoxControls = function () {
  var activity = this;
  $('.infogroup-header[data-contents="alerts"], .infogroup-header[data-contents="tweets"]').click(function (e) {
    var $infogroup = $('.infogroup .infogroup-header[data-contents="' + $(this).data('contents') + '"]').parent();
    var open = !($infogroup.hasClass('state--active'));
    e.preventDefault();

    // Remove the 'new' items in this infobox
    if (open) {
      $infogroup.find('.marker--new').remove();
    }

    activity.closeAllInfoboxes();
    if (open) {
      activity.openInfobox($(this).data('contents'));
    }
  });
};

/* Moves the scroll point of an info box to the top */
SharkActivity.prototype.resetInfoboxScrolling = function (type) {
  var $infobox_items = $('.infogroup .infogroup-header[data-contents="' + type + '"]').parent().find('.infogroup-items');
  if ($infobox_items.length) {
    $infobox_items[0].scrollTop = 0;
  }
};

/* Closes all of the info boxes */
SharkActivity.prototype.closeAllInfoboxes = function () {
  var activity = this;
  $('.infogroup-wrapper .infogroup').each(function () {
    activity.resetInfoboxScrolling($(this).find('.infogroup-header').data('contents'));
  });

  $('.shark-activity-navigation').removeClass('state--popupactive');
  $('.infogroup-wrapper .infogroup.state--active').removeClass('state--active');

  // If we have an active popup, watch its scrolling.
  /* if ($('.shark-activity-details-list').length) {
      this.setupScrollToBottomWatch(
          $('.shark-activity-details-list'),
          function($el) {
              // bottom callback
              $el.addClass('state--nooverflow');
          },
          function($el) {
              // not bottom callback
              $el.removeClass('state--nooverflow');
          }
      );
  } */
};

/* Watch a given element's scrolling and notify the callabck methods if the scrolling is at the bottom, or not. */
SharkActivity.prototype.setupScrollToBottomWatch = function ($el, bottom_callback, notbottom_callback) {
  $el.unbind('scroll').scroll(function (e) {
    var $el = $(e.currentTarget);
    if ($el[0].scrollHeight - $el.scrollTop() <= $el.outerHeight()) {
      bottom_callback($el);
    } else {
      notbottom_callback($el);
    }
  });

  // For when there are not enough items
  if ($el[0].scrollHeight <= $el.outerHeight()) {
    bottom_callback($el);
  }
};

/** Restore the last open target */
SharkActivity.prototype.openLast = function () {
  var self = this;
  if (self.lastOpen) {
    var marker = self.lastOpen;
    window.setTimeout(function () {
      self.markerClick(self.pinmap, marker);
    }, 10);
  }
};

/** Reset any pending notifications */
SharkActivity.prototype.resetNotifications = function (hard) {
  // Hard reset resets all state
  if (hard) {
    this.watcher.clear();
    this.closeNotificationsPanel();
    this.openLast();
  }

  // Soft reset simply rebuilds the content for each marker
  else {
    if (this.summaryOpen) {
      this.openLast();
    }
  }

  // Reset state
  this.lastOpen = null;
};

/** Handle a click to open a marker by name */
SharkActivity.prototype.handleMarkerEvent = function (event) {
  this.cutoff = this._oldest_unused_cutoff;
  this._oldest_unused_cutoff = Math.floor(new Date().getTime() / 1000);
  this.markerClick(this.pinmap, this.index[event], true);
  this.pinmap.google_map.setZoom(15);
};

/** Clear an item from the bar, maybe close the bar */
SharkActivity.prototype.clear = function (key, $root) {
  // Update banner
  this.watcher.clear(key);
  $root.addClass('state--inactive');
  if (!this.watcher.any()) {
    this.closeNotificationsPanel();
  }
};

/** Specific time formatting for the notification bar */
SharkActivity.prototype.format_time = function (t) {
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var ampm = t.getHours() > 11 ? 'pm' : 'am';
  var hour = t.getHours() > 12 ? t.getHours() - 12 : t.getHours();
  var min = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes();
  var month = months[t.getMonth()];
  var day = t.getDate();
  return "" + hour + "." + min + ampm + " " + day + " " + month;
};

SharkActivity.prototype.openInfobox = function (type) {

  // Close any open pinmaps
  this.pinmap.popup.close();

  this.closeAllInfoboxes();
  $('.infogroup-header[data-contents="' + type + '"]').parent().addClass('state--active');
  $('.shark-activity-navigation').addClass('state--popupactive');
  // Close the filter nav
  $('.filterset--key.state--active').removeClass('state--active');

  /* this.setupScrollToBottomWatch(
      $('.infogroup-header[data-contents="' + type + '"]').parent().find('.infogroup-items'),
      function($el) {
          // bottom callback
          $el.parent().find('.infogroup-overflowindicator').addClass('state--inactive');
      },
      function($el) {
          // not bottom callback
          $el.parent().find('.infogroup-overflowindicator').removeClass('state--inactive');
      }
  ); */
};

/** Handle shark updates and callback */
SharkActivity.prototype.updated = function (summary, watcher) {
  var activity = this;

  // Various elements to work on
  var $notes = $('#notification-panel');
  var $time = $notes.find('.notification-time');
  var $detections = $notes.find('.notification--detection').parent();
  var $sighting = $notes.find('.notification--sighting').parent();
  var $tweets = $notes.find('.notification--tweet').parent();
  var self = this;

  // Show panel
  $notes.addClass('state--active');
  $time.text("New alerts since " + self.format_time(summary.timestamp));
  $('body').addClass('notification--active');
  $('body').trigger('notifications-toggled');

  // Update helper
  var updater = function (key, collection, $root) {
    if (collection && collection.length) {
      $root.removeClass('state--inactive');
      $root.find('.notification-count').text(collection.length.toString());
      $root.unbind('click');

      $root.click(function (e) {
        activity.untouchMarkers();
        self.clear(key, $root);
        if (key === 'twitter') {
          activity.openInfobox('tweets');
          activity.resetInfoboxScrolling('tweets');
        } else {
          var active = {};
          active[key] = true;
          var records = [];
          for (var i = 0; i < collection.length; ++i) {
            var loc = collection[i][1].location;
            var line = collection[i][0].replace(new RegExp(loc, 'g'), '<a href="#"" onclick="openMapMarker(\'' + loc + '\'); return false;">' + loc + '</a>');
            records.push({
              type: key,
              line: line
            });
          }
          var stash = {
            active: active,
            records: records
          };

          self.reload(false, function () {
            self.pinmap.popup.setContent(self.action_template(stash));
            self.pinmap.popup.open();
            self.summaryOpen = true;

            // Close all info boxes
            activity.closeAllInfoboxes();

          }, true, watcher.time(key));
        }
        e.preventDefault();
      });

      if (key === 'twitter') {
        activity.updateTweets(collection);
      } else {
        // Add new sharks to the map
        activity.reload(activity.$ui.find('.filter-time').val());
      }
    } else {
      $root.addClass('state--inactive');
      $root.unbind('click');
    }
  };

  // Update counts
  this.summary = summary;
  updater('twitter', summary.twitter, $tweets);
  updater('detection', summary.detection, $detections);
  updater('sighting', summary.sighting, $sighting);
};

/**
 * As per reload, but now the logic in this is so complex use a timer to
 * make sure we don't spam reload.
 */
var _rtimer = null;
SharkActivity.prototype.reload = function (id, callback, use_cache, timestamp) {
  var self = this;
  if (_rtimer !== null) {
    window.clearTimeout(_rtimer);
  }
  _rtimer = window.setTimeout(function () {
    _rtimer = null;
    self._reload(id, callback, use_cache, timestamp);
  }, 100);
};

/** Reload data from bound data values */
SharkActivity.prototype._reload = function (id, callback, use_cache, timestamp) {
  if (this.cache === null) {
    use_cache = false;
  }
  if (id) {
    this.cache_id = id;
  } else {
    id = this.cache_id;
  }
  var activity = this;
  var timeout = new Date().getTime();
  var update_handler = function (data) {

    if (activity.drumline_active !== data.smart_drumlines_active) {
      activity.drumline_active_changed = true;
    }

    if (data && typeof data.smart_drumlines_active !== 'undefined') {
      activity.drumline_active = data.smart_drumlines_active;
    }

    if (data && data.feed) {
      data = data.feed;
    }
    if (data && data.length) {
      activity.cache = $.map(data, function (i) {
        return $.extend({}, i);
      });
    } else {
      activity.cache = [];
    }
    if (!use_cache) {
      activity.pinmap.clearMarkers(null);
      activity.drumline_markers = [];
    }
    activity.showSafetyLayers();
    if (!data || data.length === 0) {
      var empty_map = new activity.PopupSlider(activity.$map);
      var string = 'timeframe';
      switch (id) {
        case '01':
        case undefined:
          string = '24 hours';
          break;
        case '02':
          string = '7 days';
          break;
        case '03':
          string = '30 days';
          break;
      }

      empty_map.setContent(activity.empty_template({
        timespan: string
      }));
      empty_map.open();

      // Callback if any
      if (callback) {
        callback();
      }
    } else {
      // Hide the 'no reported detections' popup, if it exists
      $('.no-reports').parent().parent().removeClass('state-active');

      // Remove all the "new" listings, they are re added.
      $('.shark-activity-details-list').find('.marker--new').each(function () {
        $(this).parent().remove();
      });

      // remove time filtered flags
      $(activity.pinmap.markers).each(function (i, marker) {
        if (marker.time_filtered !== undefined) {
          marker.time_filtered = false;
        }
      });

      $(data).each(function (i, item) {
        var point, content;
        var update_summary = false;
        if (item.latitude && item.longitude) {
          point = new window.google.maps.LatLng(item.latitude, item.longitude);
          // Format the shark sightings.
          var list_string = '';
          for (var i2 = 0; i2 < item.list.length; ++i2) {
            var cutoff = timestamp ? timestamp : activity.cutoff;
            var new_item = item.list[i2][1].timestamp > cutoff ? '<span class="marker--new"></span>' : "";
            var species = item.list[i2][1].species.replace(' ', '-');
            var new_list_string = '';
            var $open_popup_for_location = $('.shark-activity-popup-content-primary-location[data-location="' + item.list[i2][1].location + '"]');
            new_list_string += '<li class="shark-activity-popup-content-secondary-item species-' + species + '">' + new_item;
            new_list_string += item.list[i2][0];
            new_list_string += '</li>';

            // If this new item and this location has its popup open, append it and show the new marker.
            if (new_item.length && $open_popup_for_location.length) {
              $open_popup_for_location.parent().find('.shark-activity-details-list').prepend(new_list_string);
              update_summary = true;
            }

            list_string += new_list_string;
          }
          item.list = list_string;

          // Format the summary string
          var summary_string = '<li>' + item.summary_list.join('</li><li>') + '</li>';
          item.summary_list = summary_string;
          content = activity.markerDisplay(item);

          var uid = item.type + '_' + item.longitude + '_' + item.latitude + '_' + item.timestamp;
          var marker = activity.markerExists(uid);
          if (!marker) {
            marker = activity.pinmap.addMarker(point, item.title, uid, null, content, item.type, $.inArray(item.type, activity.visible_marker_types) !== -1);
          } else {
            // Update the markers content
            marker.description = content;
            if ($.inArray(marker.type, activity.visible_marker_types) !== -1) {
              // if smart drumline, only show marker if not currently clustered
              if (marker.type === 'smart_drumline') {
                $.each(activity.drumline_cluster.clusters_, function (i, cluster) {
                  if (cluster.markers_.length === 1) { // cluster with 1 marker is not displayed a cluster so we need to show it.
                    activity.showMarker(cluster.markers_[0]);
                  }
                });
                // else just show marker
              } else {
                activity.showMarker(marker);
              }
            } else {
              activity.hideMarker(marker);
            }
          }

          // mark as time filtered
          marker.time_filtered = true;

          // set marker z indexes
          activity.setMarkerZindex(marker);

          // Almost certainly, the count of events is now wrong.
          // Generate a new summary list and inject it into the left hand side dynamically.
          if (update_summary) {
            var $summary_container = $('.shark-activity-summary-list');
            $summary_container.html(item.summary_list);
          }

          marker.append_icon_name = '';
          if (this.summary_list.indexOf('whale carcass') !== -1) {
            marker.append_icon_name = 'whale_carcass';
          }

          activity.index[item.location] = marker;
        }
      }).promise().done(function () {
        activity.zoomChanged(true);
        if (callback) {
          callback();
        }
      });
    }
  };
  if (!use_cache) {
    var time = $('.filter-time').val();
    this.cache = null;
    $.ajax(this.json_url + '?date_range=' + time + "&ie_cachebust=" + timeout).done(update_handler);
    return;
  } else {
    update_handler(this.cache);
  }
};

SharkActivity.prototype.showMarker = function (marker) {
  var activity = this;
  if (!marker.map) {
    marker.setMap(activity.pinmap.google_map);
  }
  if (!marker.visible) {
    marker.setVisible(true);
  }
}

SharkActivity.prototype.hideMarker = function (marker) {
  if (marker.visible) {
    marker.setVisible(false);
  }
}

SharkActivity.prototype.markerExists = function (id) {
  var activity = this;
  var found = false;
  $.each(activity.pinmap.markers, function (i, marker) {
    if (id === marker.id) {
      found = marker;
      return;
    }
  });
  return found;
}

SharkActivity.prototype.setMarkerZindex = function (marker) {
  var zIndex;
  switch (marker.type) {
    case 'detection':
      zIndex = 100;
      break;
    case 'sighting':
      zIndex = 99;
      break;
    case 'shark_warning_system':
      zIndex = 97;
      break;
    default:
      zIndex = 1;
  }
  marker.mapZIndex = zIndex;
  marker.setZIndex(zIndex);
  return zIndex;
}

/** Construct a raw element from the template */
SharkActivity.prototype.markerDisplay = function (item) {
  return this.marker_template(item);
};

/**
 * Update the icon of the current incident depending on the new
 * zoom level. Only updates when goes from small to large or the
 * opposite. Each icon is cached within the marker the first time
 * it is generated to save user processing.
 */
SharkActivity.prototype.zoomChanged = function () {
  var self = this;
  $.each(self.pinmap.markers, function (i, el) {
    if (typeof el.icon_normal === "undefined") {
      var icon_name = this.type;
      if (this.append_icon_name && this.append_icon_name.length > 0) {
        icon_name += '_' + this.append_icon_name;
      }
      el.icon_normal = self.makeIcon(icon_name, 'normal');
      el.icon_focus = self.makeIcon(icon_name, 'focus');
    }
    if (el.icon === null) {
      el.setIcon(el.icon_normal);
    }
  });
};

/** Reset all icons to being normal */
SharkActivity.prototype.untouchMarkers = function () {
  var self = this;
  $.each(self.pinmap.markers, function (i, el) {
    if (typeof el.icon_normal === "undefined") {
      el.icon_normal = self.makeIcon(this.type, 'normal');
      el.icon_focus = self.makeIcon(this.type, 'focus');
    }
    el.setIcon(el.icon_normal);
    // Reset to default zindex and clickable state
    self.setMarkerZindex(el);
    el.setClickable(true);
  });
};

/**
 * Create an icon definition
 * @param type The type of the marker for this icon
 * @param size One of the size keys 'large' or 'small'
 */
SharkActivity.prototype.makeIcon = function (type, size) {
  if (typeof (this.icon_styles[type]) === 'undefined') {
    return null;
  }
  var pin_data = this.icon_styles[type].pin_data[size];
  var rtn = {};
  for (var attrib in pin_data) {
    if (pin_data.hasOwnProperty(attrib)) {
      rtn[attrib] = pin_data[attrib];
    }
  }
  rtn.url = this.icon_styles[type][size + '_image'];
  return rtn;
};

/**
 * Custom click even for map markers to set the new size of the marker
 * as well as the popup.
 * @param pinmap The map that owns the marker
 * @param marker The marker that was clicked
 */
SharkActivity.prototype.markerClick = function (pinmap, marker, keep_cutoff) {

  var current_marker = pinmap.currentMarker();
  if (current_marker !== null) {
    current_marker.setCurrent(false, current_marker);
  }

  // Update cutoff if not a click through from summary page
  if (!keep_cutoff) {
    this.cutoff = Math.floor(new Date().getTime() / 1000);
  }

  var self = this;
  self.untouchMarkers();
  this.reload(false, function () {

    // Find active marker
    $.each(self.pinmap.markers, function (i, el) {
      // Reset to default zindex and clickable state
      self.setMarkerZindex(el);
      el.setClickable(true);
      if (el.id == marker.id) {
        marker = el;
      }
    });

    if (marker) {
      marker.setZIndex(200);
      marker.setClickable(false);
      marker.setCurrent(true, marker);
      pinmap.showMarker(marker);
      self.lastOpen = marker;
      marker.setIcon(marker.icon_focus);
    }

    self.summaryOpen = false;

    // Close all info boxes
    self.closeAllInfoboxes();
  }, true);
};

/**
 * Change the filter state for a certain class of markers
 * @param type The type of marker to filter.
 */
SharkActivity.prototype.updateFilters = function (type) {
  this.toggleMarkers(type);
};

/**
 * Change the date range for the map, based on the markers in the ui.
 * @param ui The body ui element.
 */
SharkActivity.prototype.updateDateRange = function ($ui) {
  var id = $ui.find('.filter-time').val();
  this.reload(id);

  // Close the notifications panel
  this.closeNotificationsPanel();

  // Untouch markers and close the toast popup
  this.untouchMarkers();
  this.PopupSlider(this.$map).close();
};

SharkActivity.prototype.closeNotificationsPanel = function () {
  var panel = $('#notification-panel');
  var alert = panel.hasClass('state--active');
  if (alert) {
    panel.addClass('state--removing');
  }
  panel.removeClass('state--active').removeClass('state--active-ben');
  $('body').removeClass('notification--active');
  $('.slide-item .state--active').removeClass('state--active');
  $('body').trigger('notifications-toggled');
  setTimeout(function () {
    panel.removeClass('state--removing');
  }, 1000);
};

/** Icon styles */
SharkActivity.prototype.iconStyles = function (images_url) {
  // Set icon sizes here
  var ns = 32;
  var fs = 64;

  var icon_styles = {};
  $.each(['detection', 'closure', 'sighting', 'sighting_whale_carcass', 'safety_net', 'patrolled_beach', 'satellite_receiver', 'shark_warning_system'], function (index, type) {
    icon_styles[type] = {
      normal_image: images_url + 'map-icon-' + type + '.png',
      focus_image: images_url + 'map-icon-' + type + '-focus.png',
      pin_data: {
        normal: {
          scaledSize: new window.google.maps.Size(ns, ns),
          size: new window.google.maps.Size(ns, ns),
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point(ns / 2, ns)
        },
        focus: {
          scaledSize: new window.google.maps.Size(fs, fs),
          size: new window.google.maps.Size(fs, fs),
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point(fs / 2, fs)
        }
      }
    };
  });

  var whale_scale = 1.2;
  icon_styles.sighting_whale_carcass.pin_data.normal.scaledSize = new window.google.maps.Size(45, 45);
  icon_styles.sighting_whale_carcass.pin_data.normal.size = new window.google.maps.Size(45, 45);
  icon_styles.sighting_whale_carcass.pin_data.normal.anchor = new window.google.maps.Point(34, 39);
  icon_styles.sighting_whale_carcass.pin_data.focus.scaledSize = new window.google.maps.Size(fs * whale_scale, fs * whale_scale);
  icon_styles.sighting_whale_carcass.pin_data.focus.size = new window.google.maps.Size(fs * whale_scale, fs * whale_scale);
  icon_styles.sighting_whale_carcass.pin_data.focus.anchor = new window.google.maps.Point(56, 60);
  return icon_styles;
};

/** Draw the twitter activity feed */
SharkActivity.prototype.updateTweets = function (data) {
  var $parent = $('#twitter-activity-parent');
  // if the tweet module was already created, any tweets coming in now are now
  var tweet_is_new = $parent.find('.infogroup-items .infogroup-item').length > 0;

  var process_data = function (data) {
    var $feed = $('#twitter-activity-feed');

    if (data.length) {
      // Clear the empty message.
      $feed.find('[data-itemtype="tweet-empty"]').remove();

      var empty_template = Handlebars.compile($('#shark_activity_twitter').html());
      for (var index in data) {
        data[index].tweet_is_new = tweet_is_new;
        if (!$feed.find('#tweet_' + data[index].activity_id).length) {
          $feed.prepend(empty_template(data[index]));
        }
      }
      // When there are less than 2 items then hide the fade in element
      if ($feed.find('li.infogroup-item').length < 2) {
        $feed.parent().find('.infogroup-overflowindicator').addClass('state--inactive');
      } else {
        $feed.parent().find('.infogroup-overflowindicator').removeClass('state--inactive');
      }
    } else {
      if ($feed.find('li').length == 0) {
        $feed.parent().find('.infogroup-overflowindicator').addClass('state--inactive');
        $feed.append('<li class="infogroup-item" data-itemtype="tweet-empty"><p>There are no current alerts and warnings. Visit <a href="/news/">News & Alerts</a> for more information.</p></li>');
      }
    }
  };
  if ($parent.length) {
    if (data) {
      process_data(data);
    } else {
      window.setTimeout(function () {
        var timestamp = new Date().getTime();
        $.ajax('/shark-activity/twitter-feed?ie_cachebust=' + timestamp).done(function (data) {
          process_data(data);
        });
      }, 100);
    }
  }
};

SharkActivity.prototype.updateBeaches = function () {
  var activity = this;

  var beaches_added = false;
  var beaches = [];
  /* Change markers on zoom */
  window.google.maps.event.addListener(activity.pinmap.google_map, 'zoom_changed', function () {
    var zoom = activity.pinmap.google_map.getZoom();
    var beaches_iterator = 0;
    if (zoom >= 12) {
      if (!beaches_added) {
        beaches_added = true;
        $.ajax('/shark-activity/beaches').done(function (data) {
          $(data).each(function (i, item) {
            if (item.latitude && item.longitude) {
              var point = new window.google.maps.LatLng(item.latitude, item.longitude);
              var customTxt = '<div>' + item.name + '</div>';
              beaches.push(TxtOverlay(point, customTxt, 'google_maps_marker', activity.pinmap.google_map));
            }
          });
        });
      } else {
        for (beaches_iterator = 0; beaches_iterator < beaches.length; beaches_iterator++) {
          beaches[beaches_iterator].show();
        }
      }
    } else {
      for (beaches_iterator = 0; beaches_iterator < beaches.length; beaches_iterator++) {
        beaches[beaches_iterator].hide();
      }
    }

  });

};

/** Bind event handlers for the alerts popup */
SharkActivity.prototype._bindAlertEvents = function () {
  var self = this;
  var $alerts = $('.infogroup-header[data-contents="alerts"]');
  $alerts.click(function () {
    if ($alerts.closest('.infogroup').hasClass('state--active')) {
      if ($(this).attr('data-contents') == 'alerts') {
        self.onAlertClear();
      }
    } else {
      // Place a msg for when there are no alerts
      var $feed = $('h1.infogroup-header[data-contents="alerts"]').parent().find('.infogroup-items');
      if ($feed.find('li').length == 0) {
        $feed.parent().find('.infogroup-overflowindicator').addClass('state--inactive');
        $feed.append('<li class="infogroup-item" data-itemtype="alert-empty"><p>There are no current alerts and warnings. Visit <a href="/news/">News & Alerts</a> for more information.</p></li>');
      }
    }
  });
  $('.notification-close').click(function () {
    self.onAlertClear();
  });
  $('.notification--alerts').click(function (e) {
    self.openInfobox('alerts');
    self.resetInfoboxScrolling('alerts');
    self.closeNotificationsPanel();
    self.onAlertClear(true);
    e.preventDefault();
  });
};

/** Clear pending alerts */
SharkActivity.prototype.onAlertClear = function (keep_display) {
  this._alerts.clear();
  if (!keep_display) {
    this._rebuildAlertsList(this._alerts);
  }
};

/** Handle an alert event */
SharkActivity.prototype.onAlertEvent = function () {
  // No new items? skip
  var poll = this._alerts;
  if (poll.new_) {
    // Various elements to work on
    var $notes = $('#notification-panel');
    var $time = $notes.find('.notification-time');
    var $alerts = $notes.find('.notification--alerts').parent();

    // Convert timestamp to Date object
    var datetime = new Date(poll.oldestNewItem.modified_timestamp * 1000);

    // Show panel
    $notes.addClass('state--active');
    $time.text("New alerts since " + this.format_time(datetime));
    $alerts.removeClass('state--inactive');
    $('body').addClass('notification--active');
    $('body').trigger('notifications-toggled');

    // Update count
    $alerts.find('.notification-count').text(poll.new_);
    this._rebuildAlertsList(poll);
  }
};

/** Rebuild the activity contents */
SharkActivity.prototype._rebuildAlertsList = function (poll) {
  var block_template = function (item) {
    var rtn = '<li class="infogroup-item" data-itemtype="update"><a>';
    if (item.sticky)
      rtn += '<span class="sticky-post">Sticky</span>';
    rtn += '<p class="infogroup-item-header">';
    if (item.new_)
      rtn += '<span class="marker--new"></span> ';
    rtn += item.date;
    rtn += '</p><p>';
    rtn += item.title;
    rtn += '</p></a></li>';

    var $rtn = $(rtn);
    $rtn.find('a').attr('href', item.url);
    // If we're on the static map, make it open in a new window
    if (window.location.href.indexOf('/static') !== -1) {
      $rtn.find('a').attr('target', '_blank');
    }
    return $rtn;
  };
  var $inner_content = $('.infogroup-header[data-contents="alerts"]').parent().find('.infogroup-items');
  // Only show the overflow indicator if there is more than 1 item
  if (poll.data.length > 1) {
    $inner_content.parent().find('.infogroup-overflowindicator').removeClass('state--inactive');
  } else {
    $inner_content.parent().find('.infogroup-overflowindicator').addClass('state--inactive');
  }
  $inner_content.empty();
  for (var i = 0; i < poll.data.length; ++i) {
    $inner_content.append(block_template(poll.data[i]));
  }
};

SharkActivity.prototype.toggleMarkers = function (type, show) {
  var activity = this;
  switch (type) {

    case 'bens':
      if (show) {
        activity.bens_cluster.addMarkers(activity.ben_markers);
      } else {
        activity.bens_cluster.clearMarkers();
      }
      break;

    default:
      $.each(activity.pinmap.markers, function (i, marker) {
        if (type === marker.type) {
          if (show) {
            if (marker.time_filtered === false) {
              activity.hideMarker(marker);
            } else {
              activity.showMarker(marker);
            }
          } else {
            activity.hideMarker(marker);
          }
        }
        activity.setMarkerZindex(marker);
      });
      break;
  }
}

SharkActivity.prototype.initSafetyLayers = function () {
  var activity = this;
  var map = activity.pinmap.google_map;
  $.getJSON(activity.safety_layers_url, function (layers) {
    activity.safety_layers = activity.sortSafetyLayers(layers);
    for (var layerKey in activity.safety_layers) {
      var layer = activity.safety_layers[layerKey];
      $.each(layer, function (i, marker) {
        var close = '<span class="btn-close"></span>';
        var title = marker.title ? '<h2 data-icon="' + layerKey + '" class="shark-activity-popup-content-primary-location">' + marker.title + (
          layerKey === 'smart_drumline' ?
          activity.smart_drumlines_active ?
          '<span class="shark-activity-popup-drumlines-active state--active">active</span>' :
          '<span class="shark-activity-popup-drumlines-active">inactive</span>' :
          ''
        ) + '</h2>' : '';
        var info = marker.description ? '<div class="content-wrapper slide-content">' + marker.description + '</div>' : '';
        var content = title + close + info;
        var position = new window.google.maps.LatLng(marker.latitude, marker.longitude);
        var m = activity.pinmap.addMarker(position, marker.title, layerKey + i, null, content, layerKey, false);
        m.icon_normal = activity.makeIcon(layerKey, 'normal');
        m.icon_focus = activity.makeIcon(layerKey, 'focus');
        m.setIcon(m.icon_normal);
        activity.safety_layers[layerKey][i] = m;
        activity.safety_layers_loaded = true;
        activity.setMarkerZindex(m);
      });
    }
  });
}

SharkActivity.prototype.sortSafetyLayers = function (layers) {
  var sorted = {};
  $.each(layers, function (i, layer) {
    if (!sorted[layer.type]) {
      sorted[layer.type] = [];
    }
    sorted[layer.type].push(layer);
  });
  return sorted;
}

SharkActivity.prototype.showSafetyLayers = function () {
  var activity = this;
  for (var key in activity.safety_layers) {
    if ($.inArray(key, activity.visible_marker_types) !== -1) {
      $.each(activity.safety_layers[key], function (i, marker) {
        if (!marker.map) {
          marker.setMap(activity.pinmap.google_map);
        }
        if (!marker.visible) {
          marker.setVisible(true);
        }
      })
    }
  }
}

SharkActivity.prototype.initBens = function () {
  var activity = this;
  var map = activity.pinmap.google_map;
  activity.ben_markers = [];
  $.getJSON(this.bens_url, function (bens) {
    activity.bens = bens;
    $.each(bens, function (i, ben) {
      if (ben.latitude && ben.longitude) {
        var icon = {
          url: '/static/images/icons/map-icon-ben.png?v=2',
          labelOrigin: new google.maps.Point(25.5, 32)
        };
        var position = new window.google.maps.LatLng(ben.latitude, ben.longitude);
        var marker = new window.google.maps.Marker({
          position: position,
          //   Ben signs always sit behind everything else.
          zIndex: -1000,
          label: {
            text: ben.ben_id,
            color: 'white',
            fontSize: '11px'
          },
          icon: icon,
        });
        window.google.maps.event.addListener(marker, 'click', function () {
          var popup = new activity.PopupSlider(activity.$map);
          popup.close();
          var close = '<span class="btn-close"></span>';
          var title = '<h2 data-icon="bens" class="shark-activity-popup-content-primary-location">' + ben.display_name + '</h2>';
          var address = '<strong>Address:</strong> ' + ben.address;
          var suburb = '<strong>Suburb:</strong> ' + ben.suburb;
          var intersection = '<strong>Nearest Intersection:</strong> ' + ben.nearest_intersection;
          var info = '<div class="content-wrapper slide-content">' + address + '<br/>' + suburb + '<br/>' + intersection + '<br/><br/>Beach Emergency Numbers (BEN) aim to improve emergency response times by providing accurate location information. Quote this information in an emergency or when reporting a shark sighting.</div>';
          var content = $(title + close + info);
          popup.setContent(content);
          popup.open();
          map.panTo(position);
          activity.untouchMarkers();
        });
        activity.ben_markers.push(marker);
      }
    });

    var clustererStyles = Object.assign({}, activity.defaultClustererStyles);
    clustererStyles.url = '/static/images/icons/map-icon-multiple-bens.png';
    activity.bens_cluster = new MarkerClusterer(map, [], {
      styles: [clustererStyles],
      zoomOnClick: true,
      onClusterClick: function () {
        setTimeout(function () {
          clearTimeout(activity.drumline_polygon_zoomtimeout);
        }, 100);
      }
    });
    activity.bens_loaded = true;
  });
};

export default SharkActivity;
